import { useContext } from 'react';
import TokensContext from '../TokensContext';

export const useBackEndWebHooks = () => {
  const {backEndBaseUrl} = useContext(TokensContext);

  const callWebHook = async (url, data) => {
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        throw new Error(`Webhook responded with status ${response.status}`);
      }
    }
    catch (error) {
      console.error('Failed to call webhook:', error);
    }
  };

  const callTemperatureUpdatedWebhook = async (temp) => {
    const webhookUrl = `${backEndBaseUrl}/api/DesiredTemperature/`;
    await callWebHook(webhookUrl, {temp});
  };

  const callPositionUpdatedWebHook = async (position) => {
    const webhookUrl = `${backEndBaseUrl}/api/Heater/`;
    await callWebHook(webhookUrl, {position});
  };

  return { callTemperatureUpdatedWebhook, callPositionUpdatedWebHook };

}
export default useBackEndWebHooks ;
